import React from "react";

/* HUD-style numbered section header. */
export default function SectionHeader({ index, kicker, title }) {
  return (
    <div
      className="reveal"
      style={{
        marginBottom: "clamp(36px, 6vh, 64px)",
      }}
    >
      {/* readout row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          marginBottom: "16px",
          fontFamily: "var(--mono)",
          fontSize: "0.74rem",
          letterSpacing: "0.16em",
          textTransform: "uppercase",
        }}
      >
        <span
          style={{
            color: "var(--void)",
            background: "var(--cyan)",
            padding: "3px 8px",
            fontWeight: 700,
            boxShadow: "0 0 14px var(--glow)",
          }}
        >
          {index}
        </span>
        <span style={{ color: "var(--text-faint)" }}>{kicker}</span>
        <span
          style={{
            flex: 1,
            height: "1px",
            background:
              "linear-gradient(90deg, var(--line-strong), transparent)",
          }}
        />
      </div>

      <h2
        className="glow-text"
        style={{
          fontFamily: "var(--display)",
          fontWeight: 700,
          fontSize: "clamp(2.2rem, 6vw, 4.2rem)",
          lineHeight: 0.95,
          letterSpacing: "0.01em",
          textTransform: "uppercase",
        }}
      >
        {title}
      </h2>
    </div>
  );
}
